import React from "react";

const badgeStyle = {
  display: "inline-flex",
  alignItems: "center",
  gap: 6,
  marginBottom: 10,
  padding: "7px 12px",
  borderRadius: 999,
  border: "1px solid rgba(37, 99, 235, 0.18)",
  background: "rgba(255, 255, 255, 0.92)",
  color: "#1d4ed8",
  fontSize: 12,
  fontWeight: 800,
  letterSpacing: "0.01em",
  boxShadow: "0 10px 24px rgba(15, 23, 42, 0.08)",
};

const dotStyle = {
  width: 8,
  height: 8,
  borderRadius: 999,
  background: "#16a34a",
  boxShadow: "0 0 0 4px rgba(34, 197, 94, 0.16)",
};

const MapApiStatusBadge = ({ text = "Google Map API Licence Activated" }) => (
  <div style={badgeStyle}>
    <span style={dotStyle} />
    <span>{text}</span>
  </div>
);

export default MapApiStatusBadge;
